import { GridSizeType} from '@/shared';
import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import {
  Button,
  ButtonPropsColorOverrides,
  SvgIcon,
} from '@mui/material';

export type CreateButtonProps = {
  label?: string;
  onClick?: () => void;
  startIcon?: React.ReactNode;
  color?:
  | 'primary'
  | 'secondary'
  | 'error'
  | 'inherit'
  | 'success'
  | 'info'
  | 'warning'
  | ButtonPropsColorOverrides;

  // new
  newCustomButton?: boolean;
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  variant?: 'text' | 'outlined' | 'contained';
  showIcon?: boolean;
  iconButton?: boolean;
  size?: GridSizeType;
  width?: string;
  maxHeight?: string;
  height?: string;
  fontSize?: string;
  disabled?: boolean;

  colorSx?: string;
  backgroundSx?: string;

};

const SingleButton: React.FC<CreateButtonProps> = ({
  onClick,
  label = '',
  startIcon,
  color,
  variant = 'contained',
  showIcon = true,
  disabled = false,
  //fontSize = '14px',
  //colorSx = '',
  //backgroundSx = '',
  //iconButton = false,
  //size = gridSize,
  //width = 'none',
  //maxHeight = '40px',
  //height = '40px',
  //newCustomButton = false,
  //justifyContent = 'center',
}) => {
  //const isMobile = useIsMediaQuery('sm');

  return (
    <Button
      fullWidth
      color={(color as any) || 'primary'}
      startIcon={
        <>
          {showIcon ? (
            startIcon ? (
              <SvgIcon sx={{ fontSize: 60 }}>{startIcon}</SvgIcon>
            ) : (
              <SvgIcon fontSize="small">
                <PlusIcon />
              </SvgIcon>
            )
          ) : null}
        </>
      }
      variant={variant}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );

  /* 
  obsoleto
  return (
    <>
      {!newCustomButton ? (
        <Button
          sx={{
            maxHeight: maxHeight,
            margin: '0px 2px',
            width: width,
            height: height,
            textAlign: 'start',
            fontSize: fontSize,
            justifyContent: justifyContent,
            borderRadius: '10px',
            color: colorSx,
            background: backgroundSx,
            '&:hover': {
              backgroundColor: backgroundSx,
            },

          }}

          color={(color as any) || 'primary'}
          startIcon={
            startIcon ? <SvgIcon fontSize="small">{startIcon}</SvgIcon> : null
          }
          variant={variant}
          onClick={onClick}
          disabled={disabled}
          fullWidth
        >
          {label}
        </Button>
      ) : (
        <Grid
          item
          container
          justifyContent={isMobile ? 'start' : justifyContent}
          {...size}
        >
          {!iconButton ? (
            <Button
              color={(color as any) || 'primary'}
              startIcon={
                <>
                  {showIcon ? (
                    startIcon ? (
                      <SvgIcon   sx={{ fontSize: 60 }}>{startIcon}</SvgIcon>
                    ) : (
                      <SvgIcon fontSize="small">
                        <PlusIcon />
                      </SvgIcon>
                    )
                  ) : null}
                </>
              }
              variant={variant}
              onClick={onClick}
              disabled={disabled}
            >
              {label}
            </Button>
          ) : (
            <Tooltip title={label}>
              <IconButton
                color={color as any}
                onClick={onClick}
                disabled={disabled}
              >
                {startIcon}
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      )}
    </>
  ); */
};

export default SingleButton;
